import axios from "axios";
import request from "@/utils/request";
import { getToken } from "@/utils/auth";

const baseUrl = "/sys/file-migration";

export function precheckMigration() {
  return request({
    url: baseUrl + "/precheck",
    method: "get",
  });
}

export function initializeMigration() {
  return request({
    url: baseUrl + "/initialize",
    method: "post",
  });
}

export function startMigration() {
  return request({
    url: baseUrl + "/start",
    method: "post",
  });
}

export function pauseMigration() {
  return request({
    url: baseUrl + "/pause",
    method: "post",
  });
}

export function resumeMigration() {
  return request({
    url: baseUrl + "/resume",
    method: "post",
  });
}

export function retryFailedMigration() {
  return request({
    url: baseUrl + "/retry-failed",
    method: "post",
  });
}

export function retryVerificationFailedMigration() {
  return request({
    url: baseUrl + "/retry-verification-failed",
    method: "post",
  });
}

export function runGrayMigration() {
  return request({
    url: baseUrl + "/run-gray",
    method: "post",
  });
}

export function runOneMigration(fileId) {
  return request({
    url: baseUrl + "/run-one",
    method: "post",
    params: { fileId },
  });
}

export function queryMigrationStatus() {
  return request({
    url: baseUrl + "/status",
    method: "get",
  });
}

export function queryMigrationRecords(params) {
  return request({
    url: baseUrl + "/records",
    method: "get",
    params,
  });
}

export function queryMigrationDetail(fileId) {
  return request({
    url: baseUrl + "/detail",
    method: "get",
    params: { fileId },
  });
}

export function queryFullSourcePath(fileId) {
  return request({
    url: baseUrl + "/full-source-path",
    method: "get",
    params: { fileId, confirmed: true },
  });
}

export function queryVerificationReport() {
  return request({
    url: baseUrl + "/verification-report",
    method: "get",
  });
}

export function startFullVerification() {
  return request({
    url: baseUrl + "/start-verification",
    method: "post",
  });
}

export function startIncrementalVerification() {
  return request({
    url: baseUrl + "/start-incremental-verification",
    method: "post",
  });
}

export function startPathSwitch() {
  return request({
    url: baseUrl + "/switch-paths",
    method: "post",
    params: { confirmed: true },
  });
}

/**
 * 通用请求拦截器只处理JSON ResultVo，Excel下载需要使用独立的blob请求。
 */
export function exportMigrationFailures() {
  return axios({
    baseURL: "/api/csias",
    url: baseUrl + "/export-failures",
    method: "get",
    responseType: "blob",
    timeout: 180000,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
}
